class KlaviyoBISTrigger extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    setTimeout(() => {
      this.querySelector('.klaviyo-bis-trigger').style.display = 'block'
    }, 1500)
  }
}

customElements.define('klaviyo-bis-trigger', KlaviyoBISTrigger)
